import { $t } from '@/utils/languageAuto';

var render = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {}, [_c('breadcrumb', {
    attrs: {
      "data": _vm.breadcrumbData
    }
  }), _c('div', [_c('tip'), _c('div', {
    staticClass: "mb-10 most-big-title"
  }, [_c('span', [_vm._v(_vm._s(_vm.t('基本信息')))])]), _c('div', [_c('div', {
    staticClass: "list-row"
  }, [_c('div', {
    staticClass: "list-row-tr"
  }, [_c('div', {
    staticClass: "list-row-td"
  }, [_c('div', {
    staticClass: "list-row-item list-row-label"
  }, [_vm._v(_vm._s(_vm.t('理赔单号')))]), _c('div', {
    staticClass: "list-row-item list-row-value"
  }, [_vm._v(_vm._s(_vm.detail.claim_bill_no))])]), _c('div', {
    staticClass: "list-row-td"
  }, [_c('div', {
    staticClass: "list-row-item list-row-label"
  }, [_vm._v(_vm._s(_vm.t('理赔金额')))]), _c('div', {
    staticClass: "list-row-item list-row-value"
  }, [_vm._v(_vm._s(_vm.detail.claim_amount ? _vm.detail.claim_amount + "(" + _vm.detail.currency + ")" : ''))])]), _c('div', {
    staticClass: "list-row-td"
  }, [_c('div', {
    staticClass: "list-row-item list-row-label"
  }, [_vm._v(_vm._s(_vm.t('赔付金额')))]), _c('div', {
    staticClass: "list-row-item list-row-value"
  }, [_vm._v(_vm._s(_vm.detail.actual_compensation_amount ? _vm.detail.actual_compensation_amount + "(" + _vm.detail.currency + ")" : '--'))])]), _c('div', {
    staticClass: "list-row-td"
  }, [_c('div', {
    staticClass: "list-row-item list-row-label"
  }, [_vm._v(_vm._s(_vm.t('创建时间')))]), _c('div', {
    staticClass: "list-row-item list-row-value"
  }, [_vm._v(_vm._s(_vm._f("filterEmpty")(_vm.detail.create_time)))])])]), _c('div', {
    staticClass: "list-row-tr"
  }, [_c('div', {
    staticClass: "list-row-td"
  }, [_c('div', {
    staticClass: "list-row-item list-row-label"
  }, [_vm._v(_vm._s(_vm.t('理赔类型')))]), _c('div', {
    staticClass: "list-row-item list-row-value"
  }, [_vm._v(_vm._s(_vm.detail.claim_type_text))])]), _c('div', {
    staticClass: "list-row-td"
  }, [_c('div', {
    staticClass: "list-row-item list-row-label"
  }, [_vm._v(_vm._s(_vm.t('理赔状态')))]), _c('div', {
    staticClass: "list-row-item list-row-value"
  }, [_vm._v(_vm._s(_vm.detail.reception_status_text))])]), _c('div', {
    staticClass: "list-row-td"
  }, [_c('div', {
    staticClass: "list-row-item list-row-label"
  }, [_vm._v(_vm._s(_vm.t('问题描述')))]), _c('div', {
    staticClass: "list-row-item list-row-value"
  }, [_vm._v(_vm._s(_vm._f("filterEmpty")(_vm.detail.problem_description)))])]), _c('div', {
    staticClass: "list-row-td"
  }, [_c('div', {
    staticClass: "list-row-item list-row-label"
  }, [_vm._v(_vm._s(_vm.t('提交时间')))]), _c('div', {
    staticClass: "list-row-item list-row-value"
  }, [_vm._v(_vm._s(_vm._f("filterEmpty")(_vm.detail.submit_time)))])])]), _c('div', {
    staticClass: "list-row-tr"
  }, [_c('div', {
    staticClass: "list-row-td"
  }, [_c('div', {
    staticClass: "list-row-item list-row-label"
  }, [_vm._v(_vm._s(_vm.t('通知邮箱')))]), _c('div', {
    staticClass: "list-row-item list-row-value"
  }, [_vm._v(_vm._s(_vm.detail.notice_email))])]), _c('div', {
    staticClass: "list-row-td"
  }, [_c('div', {
    staticClass: "list-row-item list-row-label"
  }, [_vm._v(_vm._s(_vm.t('赔付时间')))]), _c('div', {
    staticClass: "list-row-item list-row-value"
  }, [_vm._v(_vm._s(_vm._f("filterEmpty")(_vm.detail.actual_claim_time)))])]), _vm._m(0), _vm._m(1)])])]), _c(_vm.orderDetailComponent, {
    tag: "component",
    attrs: {
      "code": _vm.detail.order_code
    }
  }), _vm.orderType === 1 ? [_c('div', {
    staticClass: "mt-15 mb-10 most-big-title"
  }, [_c('span', [_vm._v(_vm._s(_vm.t('装箱信息')))])]), _c('div', [_c('my-table', {
    staticClass: "import-table",
    attrs: {
      "bordered": "",
      "rowKey": "_rowKey",
      "columns": _vm.packageColumns,
      "data-source": _vm.boxingList
    },
    scopedSlots: _vm._u([{
      key: "size",
      fn: function (ref) {
        var record = ref.record;
        return [record.length || record.width || record.height ? _c('span', [_vm._v(" " + _vm._s(_vm._f("filterEmpty")(record.length)) + " * " + _vm._s(_vm._f("filterEmpty")(record.width)) + " * " + _vm._s(_vm._f("filterEmpty")(record.height)) + " ")]) : _c('span', [_vm._v("--")])];
      }
    }], null, false, 2257283858)
  })], 1)] : _vm._e(), _vm._l(_vm.detail.field_group_list || [], function (groupItem, index) {
    return _c('div', {
      key: index
    }, [groupItem.bill_field_list ? _c('div', [_c('div', {
      staticClass: "mt-15 mb-10 most-big-title"
    }, [_c('span', [_vm._v(_vm._s(groupItem.group_name))])]), _c('div', {
      staticClass: "list-row spec-cont"
    }, _vm._l(_vm.$util.arraySliceGroup(groupItem.bill_field_list, 4), function (piece, num) {
      return _c('div', {
        key: num,
        staticClass: "list-row-tr"
      }, _vm._l(piece, function (fieldItem, i) {
        return _c('div', {
          key: i,
          staticClass: "list-row-td"
        }, [_c('div', {
          staticClass: "list-row-item list-row-label"
        }, [_vm._v(_vm._s(fieldItem.field_name))]), _c('div', {
          staticClass: "list-row-item list-row-value",
          staticStyle: {
            "display": "inline-block"
          }
        }, [fieldItem.attachment_list && fieldItem.attachment_list.length ? _vm._l(fieldItem.attachment_list, function (attachItem, n) {
          return _c('div', {
            key: n,
            staticStyle: {
              "width": "100%"
            }
          }, [_c('a', {
            staticClass: "file-name-box note-attach-name",
            attrs: {
              "href": "javascript:;"
            },
            on: {
              "click": function ($event) {
                return _vm.handlePreview(attachItem);
              }
            }
          }, [_vm._v(_vm._s(attachItem.attach_name))]), _c('a', {
            staticClass: "note-attach-download ml-5",
            attrs: {
              "href": _vm.$config.rfsFileDownloadUrl + "?path=" + attachItem.attach_path + "&download=1&filename=" + attachItem.attach_name
            }
          }, [_c('a-icon', {
            attrs: {
              "type": "download"
            }
          })], 1)]);
        }) : _c('span', [_vm._v(_vm._s(fieldItem.field_value))])], 2)]);
      }), 0);
    }), 0)]) : _vm._e()]);
  }), _c('div', {
    staticClass: "mt-15 mb-10 most-big-title"
  }, [_c('span', [_vm._v(_vm._s(_vm.t('日志')))])]), _c('a-skeleton', {
    attrs: {
      "active": "",
      "loading": _vm.logLoadingStatus
    }
  }, [_c('my-table', {
    staticClass: "import-table",
    attrs: {
      "bordered": "",
      "rowKey": "id",
      "columns": _vm.logColumns,
      "data-source": _vm.logList
    },
    scopedSlots: _vm._u([{
      key: "note",
      fn: function (ref) {
        var record = ref.record;
        return [_c('div', {
          staticClass: "note-reason"
        }, [_vm._v(_vm._s(_vm._f("filterEmpty")(record.reject_reason)))]), _vm._l(record.attachment_list, function (attachItem, index) {
          return _c('div', {
            key: index,
            staticClass: "note-attach"
          }, [_c('a', {
            staticClass: "note-attach-name",
            attrs: {
              "href": "javascript:;"
            },
            on: {
              "click": function ($event) {
                return _vm.handlePreview(attachItem);
              }
            }
          }, [_vm._v(_vm._s(attachItem.attach_name))]), _c('a', {
            staticClass: "note-attach-download ml-5",
            attrs: {
              "href": _vm.$config.rfsFileDownloadUrl + "?path=" + attachItem.attach_path + "&download=1&filename=" + attachItem.attach_name
            }
          }, [_c('a-icon', {
            attrs: {
              "type": "download"
            }
          })], 1)]);
        })];
      }
    }])
  })], 1), _c('div', {
    staticClass: "pagination-box"
  }, [_c('my-pagination', {
    attrs: {
      "total": _vm.logListTotal,
      "page-size": _vm.logPageSize
    },
    on: {
      "update:pageSize": function ($event) {
        _vm.logPageSize = $event;
      },
      "update:page-size": function ($event) {
        _vm.logPageSize = $event;
      },
      "onChange": _vm.handlePageChange
    },
    model: {
      value: _vm.logPageIndex,
      callback: function ($$v) {
        _vm.logPageIndex = $$v;
      },
      expression: "logPageIndex"
    }
  })], 1)], 2)], 1);
};

var staticRenderFns = [function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "list-row-td"
  }, [_c('div', {
    staticClass: "list-row-item list-row-label"
  }), _c('div', {
    staticClass: "list-row-item list-row-value"
  })]);
}, function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "list-row-td"
  }, [_c('div', {
    staticClass: "list-row-item list-row-label"
  }), _c('div', {
    staticClass: "list-row-item list-row-value"
  })]);
}];
export { render, staticRenderFns };